import React, { createContext } from 'react'
const login=createContext({
    
}) 
export default login;